import { createPortal } from 'react-dom';
import PackDetailContent from './PackDetailContent.jsx';
import './RecipePacks.css';

/**
 * PackDetailSheet — mobile bottom sheet for pack detail.
 * Anchored to bottom, full width, max-height 88%.
 * Drag handle shown at top; backdrop click closes.
 *
 * PROTECTED presentation (DESIGN_SYSTEM.md → Protected: pack detail overlay).
 * Do not replace with DS form Modal chrome for cohesion-only reasons.
 * Shared body: PackDetailContent. Desktop counterpart: PackDetailModal.
 */
export default function PackDetailSheet({ pack, added, onClose, onAdd }) {
  if (!pack) return null;
  return createPortal(
    <div className="rp-sheet-backdrop" onClick={onClose} role="dialog" aria-modal="true" aria-label={`${pack.name} pack detail`}>
      <div className="rp-sheet-content" onClick={e => e.stopPropagation()}>
        <div className="rp-sheet-handle-row">
          <span className="rp-sheet-handle" />
        </div>
        <PackDetailContent pack={pack} added={added} onClose={onClose} onAdd={onAdd} compact={true} />
      </div>
    </div>,
    document.body
  );
}
